export default [
  {
    value: 'surname',
    text: 'Фамилия',
    type: 'string',
    description: ''
  },
  {
    value: 'name',
    text: 'Имя',
    type: 'string',
    description: ''
  },
  {
    value: 'patronymic',
    text: 'Отчество',
    type: 'string',
    description: ''
  },
  {
    value: 'phone',
    text: 'Телефон',
    type: 'string',
    description: ''
  },
  {
    value: 'email',
    text: 'Email',
    type: 'string',
    description: ''
  },
  {
    value: 'createdAt',
    text: 'Создано',
    width: 180,
    type: 'date',
    description: ''
  },
  {
    value: 'actions',
    text: 'Действия',
    width: 105,
    align: 'end',
    type: 'actions',
    sortable: false,
    description: ''
  }
]
